import { GenericAbortSignal } from 'axios';

import axiosApi from 'utils/axios';

import { getAccountId } from './auth';

export type TCustomApp = {
  id: string;
  name: string;
};

export const fetchApps = async ({ signal }: { signal?: GenericAbortSignal } = {}): Promise<TCustomApp[]> => {
  const res = await axiosApi.get(`/acc/${getAccountId()}/apps`, { signal });

  return res?.data ?? [];
};
